export default __webpack_public_path__ + "8fe91dde74f1b904f12d6a1c671d5c5a.png";